import Nuxeo from "nuxeo";

import ConfigurationManager from "../configuration/ConfigurationManager";
import URIBuilder from "../utils/URIBuilder";
import CommonContants from "../constants/CommonConstants";

const NUXEO_API_PATH = "/nuxeo";

class NuxeoClient {
  constructor() {
    let uri = new URIBuilder(ConfigurationManager.getProperty("NUXEO_HOST"));
    uri.port = ConfigurationManager.getProperty("NUXEO_PORT");
    uri.path = NUXEO_API_PATH;

    this._nuxeoAPIUri = uri.toString();
    this._nuxeoAPI = new Nuxeo({
      baseURL: uri.toString(),
    });
  }

  static _instance = null;

  static instance() {
    if (!NuxeoClient._instance) {
      NuxeoClient._instance = new NuxeoClient();
    }

    return NuxeoClient._instance;
  }

  getUser() {
    return this._nuxeoAPI
      .header("X-No-Basic-Header", true)
      .connect()
      .then((response) => {
        return response.user;
      })
      .catch((error) => {
        this.redirectToLogin();
      });
  }
  redirectToLogin() {
    let uri = new URIBuilder(ConfigurationManager.getProperty("WBCP_HOST"));
    uri.port = ConfigurationManager.getProperty("WBCP_PORT");
    uri.path = `/redirect/index.html`;

    uri.addParam("requestedUrl", window.location.href);

    window.location.href = uri.toString();
  }

  getAssets(
    page = CommonContants.FILTER_FIRST_PAGE,
    pageSize = CommonContants.FILTER_DEFAULT_PAGE_SIZE,
    search = null
  ) {
    let params = {
      pageSize: pageSize ? pageSize : CommonContants.FILTER_DEFAULT_PAGE_SIZE,
      currentPageIndex: page ? page : CommonContants.FILTER_FIRST_PAGE,
      offset: 0,
      sortBy: "dc:modified",
      sortOrder: "desc",
      queryParams:
        'public:theme != "Style Guide Package" and admin:publishYn = 1 AND admin:wbcpRegionGroup IS NULL AND admin:licenseeCodeGroup IS NULL',
      pageProvider: "WBCPAssetSearchPublic",
    };

    let options = {
      headers: {
        "X-NXproperties": "Public,picture",
        "fetch-document": "properties,lock",
        "x-nxfetch.aggregate": "key",
      },
    };

    if (search !== null) {
      for (let key in search) {
        if (key === "queryParams") {
          continue;
        }
        let value = search[key];
        params[key] = Array.isArray(value)
          ? JSON.stringify(value.map((val) => val.value))
          : value;
      }
    }

    return this._nuxeoAPI.repository().query(params, options);
  }

  getAssetDetail(uid) {
    let options = {
      headers: {
        properties: "*",
        "fetch-document": "properties,lock",
      },
    };

    return this._nuxeoAPI.repository().fetch(uid, options);
  }

  async getDownloadReport(uuid, currentPageIndex, startDate, endDate) {
    let docToFetch = uuid;
    let data = [];
    let total_pages;
    // let error = false;
    // console.log(`Searching for ${uid} for page number ${currentPageIndex}`);
    await this._nuxeoAPI
      .repository()
      .fetch(docToFetch)
      .then((doc) => {
        let queryParams = { currentPageIndex, pageSize: 1000 };
        if (startDate !== null) {
          queryParams["startEventDate"] = startDate;
        }
        if (endDate !== null) {
          queryParams["endEventDate"] = endDate;
        }

        return doc.fetchAudit(queryParams);
      })
      .then((audit) => {
        total_pages = audit.numberOfPages;
        let entries = audit.entries;
        let user_download = entries.filter(
          (entry) =>
            entry.principalName.includes("@") &&
            entry.extended.blobXPath === "file:content" &&
            entry.extended.downloadReason === "download"
        );
        user_download.map((log) => {
          let { principalName, docUUID, docPath, eventDate } = log;
          let temp_asset_name = docPath.split("/");
          let asset_name = temp_asset_name[temp_asset_name.length - 1];
          let style_guide_name = temp_asset_name[temp_asset_name.length - 2];
          if (!principalName.includes("@")) {
            return false;
          } else {
            data.push([
              docUUID,
              asset_name,
              style_guide_name,
              principalName,
              eventDate,
            ]);
          }
          return true;
        });
      });
    // .catch((err) => {
    //   console.log(
    //     `An error occurred while retrieving the document's audit log.`
    //   );
    //   console.log(err);
    //   error = true;
    //   throw new Error(err);
    // });
    return { data, total_pages };
  }

  startBulkDownload(title, files, callback) {
    // let input = files;

    // let params = {
    //   filename: title,
    // };

    // let options = {};

    // return this._nuxeoAPI
    //     .operation('Blob.BulkDownload/@async')
    //     .params(params)
    //     .input(input)
    //     .execute(options)
    //     .then((response) => this._getBulkDownloadStatus(response.headers.location, callback));

    return this._bulkDownloadAPI(title, files).then((response) => {
      // console.log(response.headers.location);
      //statusUrl = response.headers.location.split("nuxeo/")[1];
      this._getBulkDownloadStatus(response.headers.location, callback);
    });
  }

  // _getBulkDownloadStatus(statusUrl, callback) {
  //   var opts = {
  //     method: "GET",
  //     headers: {
  //       Authorization: ConfigurationManager.getProperty("NUXEO_KEY"),
  //     },
  //     redirect: "manual", //DO NOT uncomment. Not to be used
  //   };

  //   /**
  //    * The below commeted code must not be touched. This is used for different flows, which can be used later.
  //    */

  //   fetch(statusUrl, opts)
  //     .then((res) => {
  //       if (res.status !== 200 && res.status !== 0) {
  //         window.Materialize.toast(
  //           "Download Failed, please try again...",
  //           2000
  //         );
  //         callback();
  //       } else if (res.status === 0) {
  //         callback();
  //         window.Materialize.toast("Download has started...", 2000);
  //         window.open(statusUrl.replace("/status", ""), "_self");
  //       } else {
  //         setTimeout(() => {
  //           window.Materialize.toast("Download is in progress...", 2000);
  //           console.log(statusUrl);
  //           this._getBulkDownloadStatus(statusUrl, callback);
  //         }, 2000);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log("ERROR : " + err.message);
  //       console.log(err);
  //     });
  // }

  /**
   * DO NOT DELETE the above code
   */

  // _downloadZip(key, callback) {
  //   // window.open(this._nuxeoAPIUri + key, "_self");
  //   window.open(key, "_self");

  //   console.log("download url for file zip: ", key);
  //   //window.open(key, "_self");
  //   window.Materialize.toast("Download has started...", 2000);
  //   callback();
  // }

  getFile(fileUUID, properties = "*") {
    if (!fileUUID) {
      return new Promise((resolve, reject) => resolve(null));
    }

    let query = `SELECT * FROM FileArchive WHERE ecm:uuid = '${fileUUID}'`;

    let params = {
      query: query,
    };

    let options = {
      headers: {
        "X-NXproperties": properties,
        "X-NXfetch.document": "properties",
      },
    };

    return this._nuxeoAPI
      .operation("Repository.Query")
      .params(params)
      .execute(options)
      .then(
        (response) => (response.entries.length > 0 ? response.entries[0] : null)
      );
  }

  getFiles(filesUUIDs, properties = "*") {
    if (!filesUUIDs || filesUUIDs.length === 0) {
      return new Promise((resolve, reject) => resolve([]));
    }

    let fileUUIDsString = filesUUIDs
      .map((fileUUID) => `'${fileUUID}'`)
      .join(",");

    let query =
      "SELECT * " +
      "FROM FileArchive " +
      `WHERE ecm:uuid IN (${fileUUIDsString})`;

    let params = {
      query: query,
    };

    let options = {
      headers: {
        "X-NXproperties": properties,
      },
    };

    return this._nuxeoAPI
      .operation("Repository.Query")
      .params(params)
      .execute(options)
      .then((response) => response.entries);
  }

  getSubmissionReportFiles(
    page = CommonContants.FILTER_FIRST_PAGE,
    pageSize = CommonContants.FILTER_DEFAULT_PAGE_SIZE,
    sortBy = null,
    sortOrder = "ASC",
    search = null,
    reportType,
    properties = "*"
  ) {
    let response =
      reportType === "Archived"
        ? this.getArchivedSubmissions(
            page,
            pageSize,
            sortBy,
            sortOrder,
            search,
            properties
          )
        : this.getArchivedSubmissions(
            page,
            pageSize,
            sortBy,
            sortOrder,
            search,
            properties
          );

    return response;
  }

  getAssetsReportFiles(
    page = CommonContants.FILTER_FIRST_PAGE,
    pageSize = CommonContants.FILTER_DEFAULT_PAGE_SIZE,
    sortBy = null,
    sortOrder = "ASC",
    search = null,
    reportType,
    properties = "*"
  ) {
    let response =
      reportType === "Active"
        ? this.getLiveSubmissionFiles(
            page,
            pageSize,
            sortBy,
            sortOrder,
            search,
            properties
          )
        : this.getArchivedFiles(
            page,
            pageSize,
            sortBy,
            sortOrder,
            search,
            properties
          );

    return response;
  }

  // _requestAPI(location) {
  //   console.log("location: ", location);

  //   let options = {
  //     method: "GET",
  //     url: location,
  //     headers: {
  //       "Content-Type": "application/json",
  //       // 'followRedirect' : false,
  //       Authorization: ConfigurationManager.getProperty("NUXEO_KEY"),
  //     },
  //   };

  //   return new Promise((res, rej) => {
  //     request(options, function(error, response) {
  //       if (error) throw new Error(error);
  //       console.log("response from status call : ", response);
  //       res(response);
  //       return;
  //     });
  //   });
  // }

  // _bulkDownloadAPI(title, input) {
  //   var options = {
  //     method: "POST",
  //     url:
  //       this._nuxeoAPIUri.toString() +
  //       "/api/v1/automation/Blob.BulkDownload/@async",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: ConfigurationManager.getProperty("NUXEO_KEY"),
  //     },
  //     body: JSON.stringify({
  //       params: { filename: title },
  //       context: {},
  //       input: `docs:${input.join(",")}`,
  //     }),
  //   };

  //   // console.log(JSON.stringify(options, null, 2))

  //   return new Promise((res, rej) => {
  //     request(options, function(error, response) {
  //       if (error) throw new Error(error);

  //       res(response);
  //       return;
  //     });
  //   });
  // }
}

export default NuxeoClient;
